'use strict';

/**
 * An array-like class used to keep track of the external events,
 * to make possible remove all at once later on.
 *
 * @constructor
 */
var ObservableList = function () {
};

ObservableList.prototype = [];

/**
 * Remove all events listened
 */
ObservableList.prototype.off = function () {
    var i = this.length - 1;

    for (; i >= 0; i--) {
        this[i].Observed.off(this[i].evtName);
    }
};

/**
 * Register an event
 */
ObservableList.prototype.add = function (Observed, evtName, namespace, cb) {
    var registration = evtName.replace(/\s+/g, '.' + namespace + ' ') + '.' + namespace;

    Observed.on(registration, cb);
    this.push({
        Observed: Observed,
        evtName: registration
    });
};

module.exports = ObservableList;
